import { Box, ButtonGroup, IconButton, Tooltip, Zoom } from "@material-ui/core";
import { Schedule, Create, FindInPage, ThumbDownAlt, ThumbUpAlt } from "@material-ui/icons";
import { useAccessControl } from "@airborne/react-admin";
import * as React from "react";
import { FC, Fragment } from "react";
import { Datagrid, TextField, useNotify, useRefresh } from "react-admin";
import { ConfirmButton } from "../../../../Components/ConfirmButton";
import { CustomDateField } from "../../../../Components/CustomDateField";
import { DetailButton } from "../../../../Components/DetailButton";
import { EnumField } from "../../../../Components/EnumField";
import { RDDDatetimeField } from "../../../../Components/RDDDatetimeField";
import RequestStatusField from "../../../../Components/ReferenceFields/RequestStatus/RequestStatusField";
import { useAppDataProvider } from "../../../../dataprovider";
import { RequestStatus } from "../../../../Enums/RequestStatus";
import { TabbedDatagridProps } from "../../../../Models/TabbedDataGridProps";
import { SourceRequestOrder } from "../Constant/Source";

export const TabbedDatagrid: FC<TabbedDatagridProps> = props => {
  const { remarkAddClick, ordinoDateAddClick, fileDetailShowClick } = props;
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const { canCreate, canEdit, canRead, hasAccess } = useAccessControl(SourceRequestOrder);

  const acceptButtonClick = record => e => {
    record.requestStatus = RequestStatus.PoolUserAccept;
    dataProvider.updateRequestOrder(record).then(result => {
      notify(`Record updated`, "success", false, true);
      refresh();
    });
  };
  const rejectButtonClick = record => e => {
    record.requestStatus = RequestStatus.NotPlmsStatus;
    dataProvider.updateRequestOrder(record).then(result => {
      notify(`Record updated`, "success", false, true);
      refresh();
    });
  };
  const remarkOnClick = record => e => {
    e.stopPropagation();
    remarkAddClick?.(record);
  };
  const ordinoDateOnClick = record => e => {
    e.stopPropagation();
    ordinoDateAddClick?.(record);
  };

  const fileDetailOnClick = record => e => {
    e.stopPropagation();
    fileDetailShowClick?.(record);
  };

  const AcceptCustomsClearanceButton = ({ record }) => {
    return (
      <ConfirmButton
        {...props}
        variant="text"
        style={{
          color: "#12824C",
        }}
        size="medium"
        click={acceptButtonClick(record)}
      >
        <Tooltip TransitionComponent={Zoom} title="Accept">
          <ThumbUpAlt />
        </Tooltip>
      </ConfirmButton>
    );
  };
  const RejectCustomsClearanceButton = ({ record }) => {
    return (
      <ConfirmButton
        {...props}
        variant="text"
        style={{
          color: "#primary",
        }}
        size="medium"
        click={rejectButtonClick(record)}
      >
        <Tooltip TransitionComponent={Zoom} title="Reject">
          <ThumbDownAlt />
        </Tooltip>
      </ConfirmButton>
    );
  };
  const DetailsButton = ({ record }) => {
    return <DetailButton record={record} resource={"requestorders"} />;
  };
  const RemarkButton = ({ record }) => {
    return (
      <IconButton style={{ width: 40 }} onClick={remarkOnClick(record)}>
        <Tooltip TransitionComponent={Zoom} title="Core Last Update">
          <Create />
        </Tooltip>
      </IconButton>
    );
  };
  const OrdinoDateButton = ({ record }) => {
    return (
      <IconButton style={{ width: 40 }} onClick={ordinoDateOnClick(record)}>
        <Tooltip TransitionComponent={Zoom} title="Ordino Date Create Or Update">
          <Schedule />
        </Tooltip>
      </IconButton>
    );
  };

  const FileDetailButton = ({ record }) => {
    return (
      <IconButton style={{ width: 40 }} onClick={fileDetailOnClick(record)}>
        <Tooltip TransitionComponent={Zoom} title="File Detail">
          <FindInPage />
        </Tooltip>
      </IconButton>
    );
  };

  const OptButtonGroup = ({ record }) => {
    return (
      <Box style={{ flex: 1, flexDirection: "row" }}>
        <ButtonGroup variant="text" size="small">
          <DetailsButton record={record} />
          {canCreate && (
            <>
              <AcceptCustomsClearanceButton record={record} />
              <RejectCustomsClearanceButton record={record} />
              <FileDetailButton record={record} />
              <RemarkButton record={record} />
              <OrdinoDateButton record={record} />
            </>
          )}
        </ButtonGroup>
      </Box>
    );
  };

  return (
    <Fragment>
      <Datagrid optimized basePath={SourceRequestOrder}>
        <OptButtonGroup record={props} />
        <RequestStatusField label="Status" />
        <TextField source="refNo" label="Ref No" />
        <TextField source="customerPo" label="Customer Po" />
        <RDDDatetimeField label="Request Delivery Date" />
        <TextField source="customerRequestComponent" label="Pn" />
        <TextField source="unserviceable.sn" label="Core Unit SN" />
        <TextField source="unserviceable.awb" label="Core Unit AWB" />
        <EnumField
          label={"Core Unit Forwarding Agency"}
          enumName={"GetCarrierType"}
          source={"unserviceable.carrierEnum"}
        />
        <CustomDateField source="unserviceable.ordinoDate" label="Ordino Date" showTime />
        <CustomDateField source="arrivalDate" label="Arrival Date" showTime />
        <TextField source="currentPbhNote" label="Current PBH Note" />
      </Datagrid>
    </Fragment>
  );
};
